import { render } from "./BulkSkipTrackingRfid.vue?vue&type=template&id=5fc90bcf&scoped=true"
import script from "./BulkSkipTrackingRfid.vue?vue&type=script&lang=ts"
export * from "./BulkSkipTrackingRfid.vue?vue&type=script&lang=ts"

import "./BulkSkipTrackingRfid.vue?vue&type=style&index=0&id=5fc90bcf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5fc90bcf"

export default script